module.exports = __webpack_public_path__ + "static/media/doller-icon.5f1731b3.svg";